import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const cancelDeliveryRequest = createAction(ACTION.ON_CANCEL_DELIVERY_REQUEST.REQUEST, (data) => ({data}));
export const beginCancelDeliveryRequest = createAction(ACTION.BEGIN_CANCEL_DELIVERY_REQUEST, () => {});
export const endCancelDeliveryRequest = createAction(ACTION.END_CANCEL_DELIVERY_REQUEST, () => {});
